import * as tslib_1 from "tslib";
import newSyncRequestOperation from 'owa-service/lib/operation/newSyncRequestOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export function newSyncRequest(syncRequest) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        Header: getJsonRequestHeader(),
                        SyncRequest: syncRequest,
                    };
                    return [4 /*yield*/, newSyncRequestOperation(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=newSyncRequest.js.map